import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import { useNavigate } from "react-router-dom";

import "swiper/css";
import "swiper/css/navigation";
import "./HomeBanner.css";
import BannerTitle from "../../font_component/banner_title/BannerTitle";
import { useDispatch, useSelector } from "react-redux";
import { AllBanners } from "../../../features/admin/common/Slice";
import { IDS } from "../../../utils/IDS";
import WhiteButton from "../../common_components/common_button/WhiteButton";
import Cookies from "js-cookie";
import BuyModal from "../../common_components/common_modal/buy_now_modal/Buy_Modal";
import { GETProfile } from "../../../features/admin/auth/Slice";

const images = [
  "/images/home/banner_image/img1.png",
  "/images/home/banner_image/img2.png",
];

export default function HomeBanner({ profileDetails, profileStatus }) {
  const navigate = useNavigate();
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const dispatch = useDispatch();

  const isLoading = profileStatus === IDS.SLICESTATUS.Loading;

  const [showBuyModal, setShowBuyModal] = useState(false);
  const [selectedType, setSelectedType] = useState("");

  const all_banners = useSelector((state) => state?.common?.all_banners);

  useEffect(() => {
    dispatch(AllBanners());
  }, [dispatch]);

  // const handleNavigation = (type) => {
  //   Cookies.remove("shippingData");
  //   Cookies.remove("orderData");

  //   navigate("/cart", { state: { type } });
  // };

  const handleNavigation = (type) => {
    const isProfileComplete = profileDetails?.name && profileDetails?.email;

    if (!isProfileComplete) {
      setSelectedType(type);
      setShowBuyModal(true);
      return;
    }
    sessionStorage.setItem("orderType", type);

    Cookies.remove("shippingData");
    Cookies.remove("orderData");

    navigate("/cart", {
      state: { type },
    });
  };

  return (
    <section>
      <div className="home-banner">
        <Swiper
          direction="vertical"
          modules={[Navigation, Autoplay]}
          loop={true}
          className="banner-swiper"
          navigation={{
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
          }}
          onBeforeInit={(swiper) => {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
          }}
        >
          {all_banners.map((img, index) => (
            <SwiperSlide key={img.id || index}>
              <div className="banner-slide">
                <img
                  src={`${IDS.IMG_URL}${img.banner}`}
                  alt={`Banner ${index + 1}`}
                  className="banner-image"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="curve_img_div">
          <img
            src="/images/home/banner_image/white patch.png"
            className="curve_img"
            alt=""
          />
        </div>

        <div className="overlay"></div>

        {/* Navigation */}
        {all_banners?.length >= 2 && (
          <div className="banner-nav">
            <button
              ref={prevRef}
              className="banner-nav-btn "
              aria-label="Previous slide"
            >
              <span className="banner-arrow banner-arrow-up"></span>
            </button>

            <button
              ref={nextRef}
              className="banner-nav-btn "
              aria-label="Next slide"
            >
              <span className="banner-arrow banner-arrow-down"></span>
            </button>
          </div>
        )}

        {/* Content */}
        <div className="banner-content">
          <div>
            <BannerTitle
              firstText="Fuel Your Body with"
              highlightText="Spirulina"
              bannerSubText="100% natural, nutrient-rich superfood for a healthier lifestyle."
            />
            <div className="btn_holder">
              {/* ✅ Shareholder Button */}
              {!profileDetails?.shareholder && (
                <WhiteButton
                  type="Submit"
                  className="w-btn"
                  title={isLoading ? "Loading..." : "Become A Channel Partner"}
                  bg="#010E1E"
                  color="#F35F37"
                  hoverBg="#f2f2f2"
                  hoverColor="#F35F37"
                  disabled={isLoading}
                  // onClick={() =>
                  //   !isLoading &&
                  //   navigate("/cart", { state: { type: "shareholder" } })
                  // }
                  onClick={() => !isLoading && handleNavigation("shareholder")}
                />
              )}

              {/* ✅ MLM Button */}
              <WhiteButton
                className="purchase-btn"
                title={isLoading ? "Loading..." : "Business Opportunity"}
                bg="#010E1E"
                color="#F35F37"
                hoverBg="#f2f2f2"
                hoverColor="#F35F37"
                disabled={isLoading}
                // onClick={() =>
                //   !isLoading && navigate("/cart", { state: { type: "mlm" } })
                // }
                onClick={() => !isLoading && handleNavigation("mlm")}
              />
            </div>
          </div>
        </div>
      </div>

      <BuyModal
        show={showBuyModal}
        handleClose={() => {
          setShowBuyModal(false);

          navigate("/profile-settings");
        }}
      />
    </section>
  );
}
